import { createFromIconfontCN } from "@ant-design/icons"

const MyIcon = createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js", // 在 iconfont.cn 上生成
})

export default MyIcon;